import React from 'react';
import PropTypes from 'prop-types';
import './View.css';
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import Confirm from '../confirm/Confirm';
import CustomerService from '../../service/CustomerService';

class RemoveUserView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      username: '',
      open: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.statefulInitialization = this.statefulInitialization.bind(this);
  }

  componentDidMount() {
    const { requestedState, } = this.props;
    if (requestedState) {
      this.statefulInitialization(requestedState);
    }
  }

  INPUT_BOX_ID = 'view.removeuser.text';

  handleClickOpen = () => {
    this.setState({ open: true, });
  };

  handleClose = () => {
    this.setState({ open: false, });
  };

  handleChange(event) {
    this.setState({ username: event.target.value.toLowerCase().trim(), });
  }

  statefulInitialization(customerProfile) {
    this.setState({
      username: customerProfile.username,
    });
  }

  submitRemoveUser({ username, }) {
    this.reset();
    if (this.isValid(username)) {
      this.setState({ isLoading: true, });

      CustomerService.removeUser({
        username: username.toLowerCase().trim(),
      })
        .then(() => {
          this.setState({
            status: (
              <Alert dismissible className="mt-2" variant="success">
                <Alert.Heading>Success!</Alert.Heading>
                <p>{`User ${username} was successfully removed`}</p>
              </Alert>
            ),
          });
        })
        .catch(() => {
          this.setState({
            status: (
              <Alert dismissible className="mt-2" variant="danger">
                <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
                <p>{`Unable to remove user ${username}`}</p>
              </Alert>
            ),
          });
        })
        .finally(() => {
          this.handleClose();
          this.setState({ isLoading: false, });
        });
    }
  }

  reset() {
    this.setState({
      status: null,
    });
  }

  isValid(usernameInput) {
    if (!usernameInput || usernameInput === '' || /^\s*$/.test(usernameInput)) {
      return false;
    }
    return true;
  }

  render() {
    const vm = this;
    const {
      username, isLoading = false, status, open,
    } = this.state;
    return (
      <div className="content mt-2">
        <span className="lead">Remove User</span>
        <input
          id={vm.INPUT_BOX_ID}
          className="form-control"
          placeholder="Enter username"
          value={username}
          onChange={this.handleChange}
        />
        <br />
        <Button variant="primary" onClick={this.handleClickOpen}>
          Remove User
        </Button>
        <Confirm
          isLoading={isLoading}
          title="Remove User Confirmation"
          content="Are you sure you want to remove this user?"
          open={open}
          onClose={this.handleClose}
          onYes={() => this.submitRemoveUser({ username, })}
          onNo={this.handleClose}
        />
        {status}
      </div>
    );
  }
}

RemoveUserView.defaultProps = {
  requestedState: undefined,
};

RemoveUserView.propTypes = {
  requestedState: PropTypes.instanceOf(Object),
};

export default RemoveUserView;
